// extracted by mini-css-extract-plugin
export var alertIcon = "_sg-0";